import { render, staticRenderFns } from "./profileditmezun.vue?vue&type=template&id=57f42602&"
import script from "./profileditmezun.vue?vue&type=script&lang=js&"
export * from "./profileditmezun.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports